
import * as handlebars_family from "../handlebars_family.ts";
import "../form/post-gif.mustache";
import "../widget/dropdown.ts";
const TPL = handlebars_family.addTemplate("form/giphy-dropdown",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ib data-fw-onclick=\"opendropdown\" data-widget=\"widget/dropdown\" data-fw-dropdown-commented=\"*\"><!--"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"form/post-gif"),depth0,{"name":"form/post-gif","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "--><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_gif_squared",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":127},"end":{"line":1,"column":155}}}))
    + "</icon></ib>";
},"usePartial":true,"useData":true});
export default TPL;